import '@/style/index.scss'
import { VueQueryPlugin } from '@tanstack/vue-query'
import 'virtual:uno.css'
import { createSSRApp } from 'vue'

import App from './App.vue'
import {
  prototypeInterceptor,
  requestInterceptor,
  routeInterceptor,
  shareTrackingInterceptor,
} from './interceptors'
import store from './store'
import i18n from './locales'

export function createApp() {
  const app = createSSRApp(App)
  app.use(store)
  // #ifdef MP-WEIXIN
  app.use(shareTrackingInterceptor)
  // #endif
  app.use(routeInterceptor)
  app.use(requestInterceptor)
  app.use(prototypeInterceptor)
  app.use(VueQueryPlugin)
  app.use(i18n)
  app.config.globalProperties.$t = i18n.global.t
  return {
    app,
  }
}
